import { Injectable } from "@angular/core";
import { KompanijaShort } from "app/models/auth/kompanijaShort";
import { OperacijeNadKompanijama } from "app/models/auth/operacijeKorisnikaNadKompanijama";
import { environment } from "environments/environment";

@Injectable({
    providedIn: "root",
})
export class OperacijeKorisnikaService {

    OPERACIJE_NAD_KOMPANIJAMA = "OPERACIJE_NAD_KOMPANIJAMA";

    GLOBALNA_KOMPANIJA_SIFRA = environment.globalnaKompanijaSifra;

    private operacijeNadKompanijamaProp: OperacijeNadKompanijama[] = undefined;

    constructor() { }

    kesirajOperacijeKorisnikaNadKompanijama(operacijeNadKompanijama: OperacijeNadKompanijama[]) {
        localStorage.setItem(this.OPERACIJE_NAD_KOMPANIJAMA, JSON.stringify(operacijeNadKompanijama ?? []));
        this.operacijeNadKompanijamaProp = operacijeNadKompanijama;
    }

    ocistiKesOperacijaSaKompanijama(): void {
        this.operacijeNadKompanijamaProp = null;
        localStorage.removeItem(this.OPERACIJE_NAD_KOMPANIJAMA);
    }

    get operacijeNadKompanijama(): OperacijeNadKompanijama[] {
        if (this.operacijeNadKompanijamaProp) {
            return this.operacijeNadKompanijamaProp;
        }
        let operacijeNadKompanijamaCache = localStorage.getItem(this.OPERACIJE_NAD_KOMPANIJAMA);
        if (operacijeNadKompanijamaCache) {
            this.operacijeNadKompanijamaProp = JSON.parse(operacijeNadKompanijamaCache);
            return this.operacijeNadKompanijamaProp;
        } else {
            return [];
        }
    }

    korisnikImaOperacijuGlobalno(operacija: string): boolean {
        let claim = this.operacijeNadKompanijama?.find(o => 
            o.operacije.find(x => x == operacija) == operacija && 
            o.kompanije.find(k => k == this.GLOBALNA_KOMPANIJA_SIFRA)
        );
        return claim != undefined;
    }

    korisnikImaOperacijuNadOrganizacionimEntitetom(operacija: string, orgEntitetSifra: string): boolean {
        let claim = this.operacijeNadKompanijama?.find(o => 
            o.operacije.find(x => x == operacija) == operacija && 
            o.kompanije.find(k => k == orgEntitetSifra || k == this.GLOBALNA_KOMPANIJA_SIFRA)
        );
        return claim != undefined;
    }

    korisnikImaOperacijuNadBiloKojimEntitetom(operacija: string): boolean {
        let claim = this.operacijeNadKompanijama?.find(o => 
            o.operacije.find(x => x == operacija) == operacija && 
            o.kompanije?.length > 0
        );
        return claim != undefined;
    }

    korisnikImaListuOperacijaNadEntitetom(operacije: string[], orgEntitetSifra: string): boolean {
        return operacije.every(op => {
            return this.korisnikImaOperacijuNadOrganizacionimEntitetom(op, orgEntitetSifra);
        })
    }

    korisnikImaListuOperacijaGlobalno(operacije: string[]) {
        return this.korisnikImaListuOperacijaNadEntitetom(operacije, this.GLOBALNA_KOMPANIJA_SIFRA);
    }
}